// @flow
import React from 'react';
import i18n from 'i18n-js';

import styles from './scheduleTable.css';


type WeekHeaderPropTypes = {
  title: string,
  pictureURL: string,
};

const WeekHeader = ({
  title,
  pictureURL,
}: WeekHeaderPropTypes) => (
  <tr className={styles.weekHeader}>
    <td className={styles.dayHeader}>
      {title}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.mon')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.tues')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.wed')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.thurs')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.fri')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.sat')}
    </td>
    <td className={styles.dayHeader}>
      {i18n.t('weekdays.sun')}
    </td>
  </tr>
);

export default WeekHeader;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentStopsScheduling/ScheduleTable/weekHeader.jsx